import React, { useCallback, useRef, useState } from "react";

import { EditorState } from '@codemirror/state';
import { EditorView, keymap } from '@codemirror/view';
import { defaultKeymap, indentWithTab } from '@codemirror/commands';
import { javascript } from '@codemirror/lang-javascript';
import { json } from '@codemirror/lang-json';
// import { oneDark } from '@codemirror/theme-one-dark';
import {clouds} from 'thememirror';
import { useData } from "../hooks/useData";
import { isObject } from "rant-utils";
import { useRefresh } from "../hooks/useRefresh";
import { broadcast, useChannel } from "../hooks/useChannel";
import { newID } from "../utils/unique";

export const JSEditor = (props: {
	prop: string,
	object?: any,
	lang?: "json" | "javascript",
}) => {
	const editor = React.useRef<any>(); 
	const [id] = useState(newID());

	const data = useData();

	const onUpdate = EditorView.updateListener.of((v) => {
		const raw = v.state.doc.toString();
		let val;
		
		let isValid = true;
		let msg = "";

		if (props.lang === "json") {
			try {
				val = JSON.parse(raw);

			} catch (e) {
				isValid = false;
				msg = "" + e;
			}

			broadcast(id, {
				value: msg,
			});

		} else {
			val = raw;

		}
		
		if (isValid) {
			if (props.object) {
				props.object[props.prop] = val;
			} else {
				data.setValue(props.prop, val);
			}
		}
	});

	let initialValue: string;
	if (props.object) {
		initialValue = props.object[props.prop];
	} else {
		initialValue = data.getValue(props.prop);
	}

	if (initialValue === undefined) {
		initialValue = "";
	} else if (props.lang === "json" && isObject(initialValue)) {
		initialValue = JSON.stringify(initialValue, null, 2);
	}

	React.useEffect(() => {
		const state = EditorState.create({
			doc: initialValue,
			extensions: [
				keymap.of([defaultKeymap as any, indentWithTab]),
				//oneDark,
				clouds,
				(props.lang === "json") ? json() : javascript(),
				onUpdate,
			],
		});

		const view = new EditorView({ state, parent: editor.current });

		return () => {
			view.destroy();
		};
	}, [initialValue, onUpdate]);

	return <div>
		<div ref={editor} className="js-editor"></div>
		<Err id={id} />
	</div>
};

function Err(props: {
	id: string,
}) {
	const [val, setVal] = useState("");

	useChannel(props.id, useCallback((msg) => {
		setVal(msg.value);
	}, []));

	if (!val) return null;

	return (
		<div className="bg-error text-inverse">{val}</div>
	);

}